import { neutral60opacity05, neutral60opacity20 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
import { shape } from '../shape';
import { listStyles } from './MuiListItem';
export var MuiList = {
    styleOverrides: {
        root: {
            '& [class*=MuiListItem-personName]': {
                paddingBlock: 0,
                paddingInline: rem(16),
                backgroundColor: neutral60opacity05,
                borderBottom: "".concat(rem(1), " solid ").concat(neutral60opacity05),
                borderTopLeftRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
                borderTopRightRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
                marginBottom: rem(8),
                marginTop: rem(-8),
            },
            '&:focus-visible': {
                outline: listStyles.focusVisible.outline,
            },
        },
    },
    customOverrides: {
        rowSeparator: {
            '& [class*=MuiListItem-root]': {
                borderBottom: "".concat(rem(1), " solid ").concat(neutral60opacity20),
            },
        },
        hideLastSeparator: {
            '& [class*=MuiListItem-root]:last-of-type': {
                borderBottom: 'none',
            },
        },
        zebra: {
            '& [class*=MuiListItem-root]:nth-of-type(even)': {
                backgroundColor: neutral60opacity05,
            },
        },
        topNav: { display: 'flex' },
        sideNav: {
            overflowX: 'hidden',
            paddingBlock: rem(12),
            paddingInline: rem(8),
            '& [class*=MuiDivider-root]': {
                margin: rem(16),
            },
        },
        outlineItemsOnFocus: {
            '& > [class*=MuiListItem-root]:focus, & > [class*=MuiListItemButton]:focus': {
                outline: listStyles.focusVisible.outline,
            },
        },
        tabs: {
            '& [class*=MuiListItem-root][class*=Mui-selected]': {
                background: 'transparent',
                fontWeight: 800,
            },
        },
    },
};
